import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';

const List = ({ t, requireChildSchool, ...rest }) => {
	const columns = [
		{
			header: t('LoyalChildrenReport_Parent'),
			accessor: 'parent',
			cell: (parent, row) => (<Link to={`/parents/${row.parent.id}`} > {parent.name}</Link>),
			sortable: true
		},
		{
			header: t('LoyalChildrenReport_Child'),
			accessor: 'child',
			cell: (child, row) => (<Link to={`/parents/${row.parent.id}/children/${row.child.id}`} > {child.name}</Link>),
			sortable: true
		}		
	];

	if (requireChildSchool) {
		columns.push({
			header: t('LoyalChildrenReport_School'),
			accessor: 'child.schoolName',
			sortable: true
		});
	}
	columns.push({
		header: t('LoyalChildrenReport_NumberNormalLessons'),
		accessor: 'normalLessons',
		sortable: true
	});
	columns.push({
		header: t('LoyalChildrenReport_LastLessonDate'),
		accessor: 'lastLessonDate',
		cell: lessonDate => ui.formatDate(lessonDate),
		sortable: true
	});

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);